import React, { useState, useRef, useEffect } from "react";
import styles from "./style.module.scss";
import Checkbox from "../../../../../components/Checkbox/Index";
import DropDown from "../../../../../components/DropDown/DropDown";
import KebabIcon from "../../../../../assets/svg/icons/common/kebab";
import WarningIcon from "../../../../../assets/svg/icons/common/Warning";
import RiskIcon from "../../../../../assets/svg/icons/common/risk";
import ConfirmationModal from "../../../../application/components/ConfirmationModal/ConfirmationModal";
import {
  deleteTemplate,
  saveAvailableForTemplates,
} from "../../../../../../api";
import toast from "react-hot-toast";
import useTemplateStore from "../../../../../stores/templates";
import IsAvailableForModal from "../../../components/isAvailableForModal/isAvailableForModal";
import useUserStore from "../../../../../stores/user.js";

const Row = ({ data, fetchData, history }) => {
  const loggedInUser = useUserStore((state) => state.user);
  const isPCAdmin = useUserStore((state) => state.isPCAdmin);
  const [deleteModal, setDeleteModal] = useState(false);
  const isMountedRef = useRef(true);
  const recordToEdit = useTemplateStore((state) => state.recordToEdit);
  const setRecordToEdit = useTemplateStore((state) => state.setRecordToEdit);
  const isAvailableForOpen = useTemplateStore(
    (state) => state.isAvailableForOpen,
  );
  const setIsAddTemplateModalOpen = useTemplateStore(
    (state) => state.setIsAddTemplateModalOpen,
  );
  const setIsAvailableForModalOpen = useTemplateStore(
    (state) => state.setIsAvailableForModalOpen,
  );

  useEffect(() => {
    isMountedRef.current = true;
    return () => {
      isMountedRef.current = false;
    };
  }, []);

  const dropDownOptions = [
    {
      text: "Copy Link",
      type: "normal",
      onClick: () => {
        if (loggedInUser.agent_url) {
          navigator.clipboard.writeText(
            `${window.location.origin}/v2/bank-app/${loggedInUser.agent_url}/${data.id}`,
          );
        } else {
          toast.error("Agent URL not found");
        }
        toast.success("Link copied to clipboard");
      },
    },
  ];
  if (isPCAdmin) {
    dropDownOptions.push({
      text: "Available For",
      type: "normal",
      onClick: () => {
        setRecordToEdit(data);
        setIsAvailableForModalOpen(true);
      },
    });
    dropDownOptions.push({
      text: "Edit",
      type: "normal",
      onClick: () => {
        setRecordToEdit(data);
        setIsAddTemplateModalOpen(true);
      },
    });
    dropDownOptions.push({
      text: "Delete Template",
      type: "danger",
      onClick: () => {
        setRecordToEdit(data);
        setDeleteModal(true);
      },
    });
    // dropDownOptions.push({
    //   text: "Edit Template New",
    //   type: "normal",
    //   onClick: () => {
    //     history.push(`/v2/templates/create/${data.id}`);
    //   },
    // });
  } else {
    if (loggedInUser.id === data.created_by) {
      dropDownOptions.push({
        text: "Edit",
        type: "normal",
        onClick: () => {
          setRecordToEdit(data);
          setIsAddTemplateModalOpen(true);
        },
      });
    }
  }

  const deleteTemp = () => {
    const toastId = toast.loading("Deleting...");
    deleteTemplate({ id: recordToEdit.id }).then((response) => {
      if (response?.success) {
        toast.success("Deleted successfully", { id: toastId });
        fetchData();
      } else {
        toast.error("Something went wrong", { id: toastId });
      }
      setDeleteModal(false);
    });
  };

  const saveAvailableFor = (data) => {
    saveAvailableForTemplates(data).then((response) => {
      const toastId = toast.loading("Saving...");
      if (response?.success) {
        toast.success("Available for updated successfully", { id: toastId });
        fetchData();
      } else {
        toast.error("Something went wrong", { id: toastId });
      }

      setIsAvailableForModalOpen(false);
    });
  };

  return (
    <>
      <tr className={styles.tbodyRow}>
        <td className={styles.td}>{data?.name}</td>
        <td className={styles.td}>{data?.organization?.name}</td>
        <td className={styles.td}>
          <div style={{ display: "flex", justifyContent: "flex-end" }}>
            <DropDown options={dropDownOptions} direction="bottom">
              <KebabIcon />
            </DropDown>
          </div>
        </td>
      </tr>
      {isAvailableForOpen && (
        <IsAvailableForModal
          open={isAvailableForOpen}
          onClose={() => {
            setIsAvailableForModalOpen(false)
            setRecordToEdit(null)
          }
          }
          onConfirmClick={(id, selectAll, organizations) => {
            saveAvailableFor({
              selectAll: selectAll,
              id: id,
              available_for: organizations,
            });
          }}
        />
      )}
      {deleteModal && (
        <ConfirmationModal
          open={deleteModal}
          message={`Are you sure you want to delete this template? (${recordToEdit?.name})`}
          onClose={() => {
            setDeleteModal(false);
            setRecordToEdit(null)
          }}
          onConfirmClick={deleteTemp}
        />
      )}
    </>
  );
};

export default Row;
